<template>
  <div>
    <search-bar
      @search="onSearch"
      name="detail.pr_code,detail.pr_detail,detail.pr_orispeccode,md_code"
      placeholder="输入产品、单号进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'DisassembleHourReportDetail', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{ item.md_code }}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{ item.md_date }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.detail_pr_code }} {{ item.detail_pr_detail }}</p>
          <span class="list-item-muted">{{item.md_wcname}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/report/makedisassemblehour",
      params: {
        mode: 'DETAIL'
      },
      filters: [
        {
          type: "date",
          name: "mh_date"
        }
      ]
    }
  },
  mounted() {
    this.doSearch()
  }
};
</script>

<style scoped>

</style>